
<template>
  <div>
    <!-- <h4 class="mb-4">User Projects</h4> -->
        <b-card class="mt-4">
          <b-card-header class="bg-transparent border-bottom">
            <b-row>
              <b-col>
                <h4 class="card-title mb-0">User Projects</h4>
              </b-col>
              <b-col class="col-auto">
                <div class="text-sm-end mt-2 mt-sm-0">
                  <b-button variant="primary" class="btn-rounded">
                    <i class="mdi mdi-plus me-1"></i> Add Project
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          
          <b-card-body>
            <b-row>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none profile-project-warning">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Chat App Update</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">2 year Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-warning" class="badge-soft-warning fs-10">
                          Inprogress
                        </b-badge>
                      </div>
                    </div>

                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-1.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-3.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <div class="avatar-title rounded-circle bg-light text-primary">
                                  J
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none profile-project-success">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">ABC Project Customization</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">2 month Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-primary" class="badge-soft-primary fs-10">
                          Progress
                        </b-badge>
                      </div>
                    </div>

                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-8.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-7.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-6.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <div class="avatar-title rounded-circle bg-primary">
                                  2+
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none profile-project-info">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Client - Frank Hook</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">1 hr Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-info" class="badge-soft-info fs-10">New</b-badge>
                      </div>
                    </div>

                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-4.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <div class="avatar-title rounded-circle bg-light text-primary">
                                  M
                                </div>
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-3.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none profile-project-primary">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Velzon Project</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">11 hr Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-success" class="badge-soft-success fs-10">
                          Completed
                        </b-badge>
                      </div>
                    </div>

                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-7.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-5.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none profile-project-danger">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Brand Logo Design</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">10 min Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-info" class="badge-soft-info fs-10">New</b-badge>
                      </div>
                    </div>

                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-7.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-6.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <div class="avatar-title rounded-circle bg-light text-primary">
                                  E
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none profile-project-primary">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Chat App</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">8 hr Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-warning" class="badge-soft-warning fs-10">
                          Inprogress
                        </b-badge>
                      </div>
                    </div>

                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <div class="avatar-title rounded-circle bg-light text-primary">
                                  R
                                </div>
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-3.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-8.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none profile-project-warning">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Project Update</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">48 min Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-warning" class="badge-soft-warning fs-10">
                          Inprogress
                        </b-badge>
                      </div>
                    </div>

                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-6.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-5.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-4.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none profile-project-success">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Client - Jennifer</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">30 min Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-primary" class="badge-soft-primary fs-10">
                          Process
                        </b-badge>
                      </div>
                    </div>

                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-1.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none mb-xxl-0 profile-project-info">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Bsuiness Template - UI/UX design</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">7 month Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-success" class="badge-soft-success fs-10">
                          Completed
                        </b-badge>
                      </div>
                    </div>
                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-2.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-3.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-4.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <div class="avatar-title rounded-circle bg-primary">
                                  2+
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none mb-xxl-0 profile-project-success">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Update Project</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">1 month Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-info" class="badge-soft-info fs-10">New</b-badge>
                      </div>
                    </div>
                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-7.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <div class="avatar-title rounded-circle bg-light text-primary">
                                  A
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none mb-sm-0 profile-project-danger">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">Bank Management System</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">10 month Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-success" class="badge-soft-success fs-10">
                          Completed
                        </b-badge>
                      </div>
                    </div>
                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-7.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-6.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-5.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <div class="avatar-title rounded-circle bg-primary">
                                  2+
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col xxl="3" sm="6">
                <b-card no-body class="profile-project-card shadow-none mb-0 profile-project-primary">
                  <b-card-body class="p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1 text-muted overflow-hidden">
                        <h5 class="fs-14 text-truncate">
                          <b-link href="#" class="text-dark">PSD to HTML Convert</b-link>
                        </h5>
                        <p class="text-muted text-truncate mb-0">
                          Last Update :
                          <span class="fw-semibold text-dark">29 min Ago</span>
                        </p>
                      </div>
                      <div class="flex-shrink-0 ms-2">
                        <b-badge variant="soft-info" class="badge-soft-info fs-10">New</b-badge>
                      </div>
                    </div>
                    <div class="d-flex mt-4">
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <div>
                            <h5 class="fs-12 text-muted mb-0">
                              Members :
                            </h5>
                          </div>
                          <div class="avatar-group">
                            <div class="avatar-group-item">
                              <div class="avatar-xs">
                                <img src="@/assets/images/users/avatar-7.jpg" alt=""
                                  class="rounded-circle img-fluid" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="12">
                <div class="mt-4">
                  <ul class="pagination pagination-separated justify-content-center mb-0">
                    <li class="page-item disabled">
                      <b-link href="javascript:void(0);" class="page-link"><i class="mdi mdi-chevron-left"></i>
                      </b-link>
                    </li>
                    <li class="page-item active">
                      <b-link href="javascript:void(0);" class="page-link">1</b-link>
                    </li>
                    <li class="page-item">
                      <b-link href="javascript:void(0);" class="page-link">2</b-link>
                    </li>
                    <li class="page-item">
                      <b-link href="javascript:void(0);" class="page-link">3</b-link>
                    </li>
                    <li class="page-item">
                      <b-link href="javascript:void(0);" class="page-link">4</b-link>
                    </li>
                    <li class="page-item">
                      <b-link href="javascript:void(0);" class="page-link">5</b-link>
                    </li>
                    <li class="page-item">
                      <b-link href="javascript:void(0);" class="page-link"><i class="mdi mdi-chevron-right"></i>
                      </b-link>
                    </li>
                  </ul>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        
  </div>
</template>

<script>


export default {
  name: "UserProjects",
};
</script>